import { withRouter } from 'react-router-dom';
import { graphql } from '@apollo/client/react/hoc';
import Component from './component';
import processLiqpayPaymentSuccess from './processLiqpayPaymentSuccess.graphql';

export default withRouter(
  graphql(processLiqpayPaymentSuccess, { name: 'processLiqpayPaymentSuccess' })(Component)
);
